import { PagingReactTable, Status } from "types";

export const sessionsPageSizeLimit = 100;
export const vehiclesPageSizeLimit = 100;
export const sessionExportPageSizeLimit = 250;
export const sessionExportLimit = 10000;

export const STATUS_INITIAL: Status = Object.freeze({
    loading: false,
    succeeded: false,
    error: null
})

export const STATUS_LOADING: Status = Object.freeze({
    loading: true,
    succeeded: false,
    error: null
})

export const STATUS_SUCCEEDED: Status = Object.freeze({
    loading: false,
    succeeded: true,
    error: null
})

export const STATUS_ERROR: Status = Object.freeze({
    loading: false,
    succeeded: false,
    error: { errorKey: 'SOME_ERROR_KEY' }
})

export const INITIAL_PAGING: PagingReactTable = {
    currentPage: 0,
    pageSize: 100,
    totalPages: 1,
    totalElements: 0,
}

export const TELEMATIC_TYPE_APP = 'APP';
